import React from "react";
import { InformationCircleIcon } from "@heroicons/react/solid";

export default function NotificationBanner() {
  return (
    <div className="rounded-md bg-blue-50 p-2">
      <div className="flex">
        <div className="ml-3 flex-1 md:flex md:justify-center">
          <p className="text-xs text-blue-700">
            Please be aware that these flyers are not suitable for professional
            printing. If you need a flyer to be prepared for professional
            printing, please submit a marketing ticket with the printer's
            specified bleeds and trims, and allow 24-48 hours for the
            preparation process.
          </p>
        </div>
      </div>
    </div>
  );
}
